import BookingForm from "../../components/bookingForm/BookingForm";
import ContactExplain from "../../components/contact/ContactExplain";
import Section1 from "../../components/home/section-1/Section1";
import Section2 from "../../components/home/section-2/Section2";
import Section3 from "../../components/home/section-3/Section3";
import ModalConfirmationResa from "../../components/bookingForm/ModalConfirmationResa";
import React, { useState } from "react";
import ModalImageMonthlyEvent from "../../components/monthlyEvent/ModalImageMonthlyEvent";

const imagesSection3Part1 = [
  "/assets/images/section-3-home-1.png",
  "/assets/images/section-3-home-2.png",
  "/assets/images/section-3-home-3.png"
]
const imagesSection3Part2 = [
  "/assets/images/section-3-home-4.png",
  "/assets/images/section-3-home-5.png",
  "/assets/images/section-3-home-6.png"
]
const Home = () => {
  const [showModal, setShowModal] = useState(true);
  return (
    <div className="view-home">
      <Section1/>
      <Section2/>
      <Section3 images={imagesSection3Part1} title={"Notre cuisine"} left={true} linkButton={"cartes"} titleButton={"Cartes"} paragraph={"Chez nous, chaque plat est une invitation à savourer l'authenticité et la richesse du patrimoine culinaire français. Notre cuisine rend hommage aux recettes de nos grands-mères, transmises avec amour et respect des saveurs d'antan. Nous privilégions des produits frais, locaux et de saison pour garantir des assiettes qui sont un véritable voyage au cœur des régions françaises."} titleExplain={"Découvrez l'Art de la Cuisine Française Traditionnelle"} buttonActive={true}/>
      <Section3 images={imagesSection3Part2} title={"Événements"} left={false} linkButton={"events"} titleButton={"Événements"} paragraph={"Notre restaurant, en plus de vous proposer une cuisine française authentique, est un lieu vivant où se créent des moments uniques tout au long de l’année. Ici, chaque événement est une nouvelle occasion de partager, de se retrouver et de se régaler dans une ambiance chaleureuse et festive !"} titleExplain={"Vivez des moments inoubliables avec nos événements au cœur de la cuisine française "} buttonActive={true}/>
      <div className="contact-part">
        <ContactExplain/>
      </div>
      <BookingForm/>
      {/*showModal && <ModalImageMonthlyEvent onClose={() => setShowModal(false)} />*/}
    </div>
  );
};

export default Home;
